export default __webpack_public_path__ + "static/media/webdevelopment.cab20093.jpg";